export const locationsWidgetDefaults = [
  {
    uId: 'c19aa898-5a5a-42c8-9a87-a829135c1e76',
    code: 'USA-CA',
    name: 'San Francisco, CA',
    place: {
      locality: 'San Francisco',
      area: 'CA',
      country: 'USA',
      displayName: 'San Francisco, CA USA'
    },
    focusPoint: {
      latitude: 37.7749,
      longitude: -122.4194,
      zoomLevel: 12
    },
    timezone: 'America/Los_Angeles',
    alpha2CountryCode: 'US'
  },
  {
    uId: '25ca6d8a-8729-4987-a4b4-d518508d8562',
    code: 'USA-GA',
    name: 'Atlanta, GA',
    place: {
      locality: 'Atlanta',
      area: 'GA',
      country: 'USA',
      displayName: 'Atlanta, GA USA'
    },
    focusPoint: {
      latitude: 33.7611,
      longitude: -84.3984,
      zoomLevel: 12
    },
    timezone: 'America/New_York',
    alpha2CountryCode: 'US'
  },
  {
    uId: '3ffc86e2-d123-45ed-b0ca-42ae5006bc55',
    code: 'BR',
    name: 'Rio de Janeiro',
    place: {
      locality: 'Rio de Janeiro',
      area: null,
      country: 'BR',
      displayName: 'Rio de Janeiro, BR'
    },
    focusPoint: {
      latitude: -22.9068,
      longitude: -43.2729,
      zoomLevel: 12
    },
    timezone: 'America/Rio_Branco',
    alpha2CountryCode: 'BR'
  },
  {
    uId: '4a9ea39b-e84a-4547-a729-5e0d90234201',
    code: 'WORLD',
    name: 'World',
    place: {
      locality: 'World',
      area: null,
      country: null,
      displayName: 'World'
    },
    isWorld: true,
    focusPoint: {
      latitude: 17.7611,
      longitude: -84.3984,
      zoomLevel: 3.4
    }
  },
  {
    uId: 'b4e2a031-7cd6-428f-b34b-ba1db9f3b827',
    code: 'UK',
    name: 'London',
    place: {
      locality: 'London',
      area: null,
      country: 'UK',
      displayName: 'London, UK'
    },
    focusPoint: {
      latitude: 51.5272,
      longitude: -0.0776,
      zoomLevel: 12
    },
    timezone: 'Europe/London',
    alpha2CountryCode: 'GB'
  },
  {
    uId: '4add96b2-d3e6-422d-a724-1203647236dc',
    code: 'UAE',
    name: 'Dubai',
    place: {
      locality: 'Dubai',
      area: null,
      country: 'UAE',
      displayName: 'Dubai, UAE'
    },
    focusPoint: {
      latitude: 25.0048,
      longitude: 55.2708,
      zoomLevel: 12
    },
    timezone: 'Asia/Dubai',
    alpha2CountryCode: 'AE'
  },
  {
    uId: '0ee822f0-7691-46ec-8b9e-7cd416ae920a',
    code: 'SG',
    name: 'Singapore',
    place: {
      locality: 'Singapore',
      area: null,
      country: 'SG',
      displayName: 'Singapore, SG'
    },
    focusPoint: {
      latitude: 1.3021,
      longitude: 103.8198,
      zoomLevel: 11
    },
    timezone: 'Asia/Singapore',
    alpha2CountryCode: 'SG'
  }
];